export function createReducer(handleActions, initialState = {}) {
  return function reducer(state = initialState, action, ...otherParams) {
    return handleActions[action.type] ? handleActions[action.type](state, action, ...otherParams) : state;
  };
}
export const childReducerWrapper = (hashReducers = {}, state, ...otherParams) => Object.entries(hashReducers).reduce((newState, [propName, reducer]) => {
  const currChildState = newState[propName];
  const newChildState = reducer(currChildState, ...otherParams);
  if (newChildState !== currChildState) {
    return {
      ...newState,
      [propName]: newChildState
    };
  }
  return newState;
}, state);